import { useViewContext } from '@/components/Layout/View/ViewContext';
import { layoutLogger } from '@/config/logging';
import React, { useEffect } from 'react';

interface ViewProps {
  children: React.ReactNode;
  /** Title for using in the embedding context (modal, panel, stack, window) */
  title: string | null;
}

export const View: React.FC<ViewProps> = ({ children, title }) => {
  const ctx = useViewContext();
  if (import.meta.env.DEV) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
      layoutLogger.info('View mounted', {
        title: ctx.title,
        renderMode: ctx.renderMode,
      });
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
  }

  useEffect(() => {
    if (title) {
      if (import.meta.env.DEV) {
        layoutLogger.info('Write view title: {title}', {
          title,
          renderMode: ctx.renderMode,
        });
      }
      ctx?.setTitle(title);
    }
  }, [ctx, title]);

  // In title-only mode, don't render children
  // The View component still mounts to set the title
  if (ctx.renderMode === 'title-only') {
    return null;
  }

  return (
    <div>
      {/* <div className="text-muted-foreground mb-1">{title}</div> */}
      <div>{children}</div>
    </div>
  );
};
